var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationToken(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 225.126,
    height: 165,
    viewBox: "0 0 225.126 165",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#caecf4;opacity:0.31;}.b{fill:#fafafa;}.c{fill:#e0e0e0;}.d{fill:#ebebeb;}.e{fill:#f5f5f5;}.f,.j{fill:#fff;}.g{fill:#263238;}.h{fill:#ebb500;}.i{fill:#206799;}.j{stroke:#fafafa;stroke-width:0.25px;}.k{fill:#ccc;font-size:3px;font-family:OpenSans-SemiBold, Open Sans;font-weight:600;letter-spacing:0.001em;}.l{fill:#c09401;}.m{fill:#0899ba;}.n{opacity:0.82;}.o{fill:#3b6884;}.p{fill:#337ead;}.q{fill:#ffbe9d;}.r{opacity:0.3;}.s{fill:#eb996e;}.t{fill:#455a64;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-485 -152.705)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(485 152.705)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-790.869-2689.174s31.161-4.784,37.79-25.284,61.024-33.28,93.62-7.073,27.1,32.562,56.035,34.168,15.512,32.323-2.494,37.345-18.451,49.646-34.851,56.718-92.7,40.318-114.564,8.44-58.529-41.719-56.274-72.436S-790.869-2689.174-790.869-2689.174Z",
    transform: "translate(811.708 2736.267)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.447 15.643)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.588 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 128.039,
    height: 100.152,
    transform: "translate(0.058 0.092)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M163.277,134.484c0-.607-.031-39.712-.075-100.152l.075.071L35.248,34.42h0l.088-.088V134.484l-.078-.078,128.04.078-128.04.078H35.18V34.24h128.2v.075C163.3,94.772,163.277,133.877,163.277,134.484Z",
    transform: "translate(-35.18 -34.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M73.844,82.77H66.293a.946.946,0,0,1-.943-.956V71.376a.946.946,0,0,1,.943-.946h4.788l3.706,3.822v7.562a.946.946,0,0,1-.943.956Z",
    transform: "translate(-55.119 -58.158)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M82.25,70.43v2.943a.878.878,0,0,0,.878.878h2.828Z",
    transform: "translate(-66.289 -58.158)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M82.37,79.87a.973.973,0,0,0,.773.946.444.444,0,0,0,.092.02c.37.068,2.8.5,2.8.444v-.79H83.208S82.5,80.467,82.37,79.87Z",
    transform: "translate(-66.368 -64.397)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M73.791,82.72a1,1,0,0,0,.163-.02.956.956,0,0,0,.427-.2.936.936,0,0,0,.339-.678c0-.305,0-.658,0-1.055V74.188h0L71,70.4H66.453a2.557,2.557,0,0,0-.363,0,.905.905,0,0,0-.573.393.888.888,0,0,0-.183.454V81.556a2.179,2.179,0,0,0,0,.4.916.916,0,0,0,.777.729,2.677,2.677,0,0,0,.37,0h0a3.512,3.512,0,0,1-.376,0,.915.915,0,0,1-.37-.132.97.97,0,0,1-.454-.641,2.034,2.034,0,0,1,0-.407V71.255a.956.956,0,0,1,.18-.5.99.99,0,0,1,.634-.393,1.986,1.986,0,0,1,.373,0h4.574l3.713,3.818h0v7.633a.956.956,0,0,1-.339.678.987.987,0,0,1-.437.2h-.122Z",
    transform: "translate(-55.067 -58.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M85.877,74.159H83.015a.922.922,0,0,1-.658-.309.953.953,0,0,1-.183-.339,1.018,1.018,0,0,1-.041-.359V70.29a.194.194,0,0,1,0,.075v2.787a.868.868,0,0,0,.21.644.855.855,0,0,0,.61.288h2.791C85.854,74.152,85.877,74.156,85.877,74.159Z",
    transform: "translate(-66.21 -58.066)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M74.071,78.1c0,.02-.892.034-1.991.034s-1.991,0-1.991-.034.888-.034,1.991-.034S74.071,78.087,74.071,78.1Z",
    transform: "translate(-58.252 -63.207)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M75.96,82.434s-1.312.034-2.933.034-2.937,0-2.937-.034S71.4,82.4,73.027,82.4,75.96,82.414,75.96,82.434Z",
    transform: "translate(-58.252 -66.069)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M75.96,86.76c0,.02-1.312.034-2.933.034s-2.937,0-2.937-.034,1.312-.031,2.937-.031S75.96,86.743,75.96,86.76Z",
    transform: "translate(-58.252 -68.931)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M75.96,91.084s-1.312.034-2.933.034-2.937,0-2.937-.034,1.312-.034,2.937-.034S75.96,91.067,75.96,91.084Z",
    transform: "translate(-58.252 -71.786)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M75.96,95.414s-1.312.031-2.933.031-2.937,0-2.937-.031,1.312-.034,2.937-.034S75.96,95.394,75.96,95.414Z",
    transform: "translate(-58.252 -74.648)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M75.96,100.744c0,.02-1.312.034-2.933.034s-2.937,0-2.937-.034,1.312-.034,2.937-.034S75.96,100.727,75.96,100.744Z",
    transform: "translate(-58.252 -78.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M74.816,115.878c0,.051-2.1.088-4.676.088s-4.68-.037-4.68-.088,2.1-.088,4.68-.088S74.816,115.831,74.816,115.878Z",
    transform: "translate(-55.192 -88.137)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M76.4,119.468a25.163,25.163,0,0,1-3.008.088,25.2,25.2,0,0,1-3.011-.088,26.089,26.089,0,0,1,3.011-.088A26.05,26.05,0,0,1,76.4,119.468Z",
    transform: "translate(-58.444 -90.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M73.844,161.546H66.293a.946.946,0,0,1-.943-.946V150.156a.946.946,0,0,1,.943-.946h4.788l3.706,3.822V160.6a.946.946,0,0,1-.943.946Z",
    transform: "translate(-55.119 -110.224)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M82.25,149.2v2.943a.878.878,0,0,0,.878.878h2.828Z",
    transform: "translate(-66.289 -110.217)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M82.37,158.64a.973.973,0,0,0,.773.946l.092.02c.37.068,2.8.5,2.8.444v-.79H83.208S82.5,159.237,82.37,158.64Z",
    transform: "translate(-66.368 -116.456)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M73.825,161.49a1,1,0,0,0,.163-.02.957.957,0,0,0,.427-.2.936.936,0,0,0,.339-.678v-7.616l-3.717-3.8H66.486a2.557,2.557,0,0,0-.363,0,.905.905,0,0,0-.573.393.889.889,0,0,0-.166.465v10.295a2.182,2.182,0,0,0,0,.4.916.916,0,0,0,.777.729,2.677,2.677,0,0,0,.37,0h0a3.528,3.528,0,0,1-.376,0,.915.915,0,0,1-.37-.132.97.97,0,0,1-.454-.641,2.036,2.036,0,0,1,0-.407V150.025a.956.956,0,0,1,.18-.5.99.99,0,0,1,.634-.393,1.983,1.983,0,0,1,.373,0h4.557l3.7,3.822h0v7.633a.956.956,0,0,1-.339.678.987.987,0,0,1-.437.2h-.122Z",
    transform: "translate(-55.1 -110.167)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M85.877,152.929H83.015a.922.922,0,0,1-.658-.309.952.952,0,0,1-.183-.339,1.017,1.017,0,0,1-.041-.359V149.06a.194.194,0,0,1,0,.075v2.787a.868.868,0,0,0,.21.644.854.854,0,0,0,.61.288h2.791C85.854,152.922,85.877,152.926,85.877,152.929Z",
    transform: "translate(-66.21 -110.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M74.071,156.874c0,.02-.892.034-1.991.034s-1.991,0-1.991-.034.888-.034,1.991-.034S74.071,156.857,74.071,156.874Z",
    transform: "translate(-58.252 -115.267)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M75.96,161.2s-1.312.034-2.933.034-2.937-.017-2.937-.034,1.312-.034,2.937-.034S75.96,161.184,75.96,161.2Z",
    transform: "translate(-58.252 -118.128)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M75.96,165.53c0,.02-1.312.034-2.933.034s-2.937,0-2.937-.034,1.312-.031,2.937-.031S75.96,165.513,75.96,165.53Z",
    transform: "translate(-58.252 -120.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M75.96,169.854c0,.017-1.312.034-2.933.034s-2.937-.017-2.937-.034,1.312-.034,2.937-.034S75.96,169.837,75.96,169.854Z",
    transform: "translate(-58.252 -123.845)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M75.96,174.184c0,.017-1.312.03-2.933.03s-2.937,0-2.937-.03,1.312-.034,2.937-.034S75.96,174.164,75.96,174.184Z",
    transform: "translate(-58.252 -126.707)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M75.96,179.514c0,.02-1.312.034-2.933.034s-2.937,0-2.937-.034,1.312-.034,2.937-.034S75.96,179.5,75.96,179.514Z",
    transform: "translate(-58.252 -130.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M74.816,194.648c0,.051-2.1.088-4.676.088s-4.68-.037-4.68-.088,2.1-.088,4.68-.088S74.816,194.6,74.816,194.648Z",
    transform: "translate(-55.192 -140.196)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M76.4,198.237a25.164,25.164,0,0,1-3.008.088,25.189,25.189,0,0,1-3.011-.088,26.089,26.089,0,0,1,3.011-.088A26.05,26.05,0,0,1,76.4,198.237Z",
    transform: "translate(-58.444 -142.561)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M72.314,258.17H64.763a.946.946,0,0,1-.943-.946V246.776a.946.946,0,0,1,.943-.946h4.788l3.706,3.822v7.572a.946.946,0,0,1-.943.946Z",
    transform: "translate(-54.108 -174.081)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M80.72,245.83v2.94a.878.878,0,0,0,.878.878h2.828Z",
    transform: "translate(-65.278 -174.081)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M80.84,255.26a.977.977,0,0,0,.773.949.781.781,0,0,0,.095.02c.366.068,2.8.5,2.8.444v-.79H81.678S80.972,255.85,80.84,255.26Z",
    transform: "translate(-65.357 -180.313)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M72.275,258.107a1,1,0,0,0,.163-.02.956.956,0,0,0,.427-.2.936.936,0,0,0,.339-.678v-7.633h0l-3.717-3.784H64.937a2.15,2.15,0,0,0-.363,0,.905.905,0,0,0-.59.37.888.888,0,0,0-.166.465v10.295a2.536,2.536,0,0,0,.024.434.916.916,0,0,0,.777.729,3.341,3.341,0,0,0,.37,0h-.017a2.827,2.827,0,0,1-.376,0,.973.973,0,0,1-.824-.729,2.055,2.055,0,0,1,0-.407v-10.3a.973.973,0,0,1,.814-.892,2.326,2.326,0,0,1,.373-.017h4.568l3.713,3.818h0v7.633a.956.956,0,0,1-.339.678.922.922,0,0,1-.437.193.674.674,0,0,1-.122,0Z",
    transform: "translate(-54.069 -174.018)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M84.348,249.559H81.486a.909.909,0,0,1-.654-.309.939.939,0,0,1-.187-.339,1.017,1.017,0,0,1-.041-.359V245.69a.193.193,0,0,1,0,.075v2.787a.875.875,0,0,0,.21.644.838.838,0,0,0,.61.285h2.791A1.451,1.451,0,0,0,84.348,249.559Z",
    transform: "translate(-65.199 -173.988)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M72.541,253.5c0,.017-.892.034-1.99.034s-1.991,0-1.991-.034.892-.034,1.991-.034S72.541,253.487,72.541,253.5Z",
    transform: "translate(-57.241 -179.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M74.43,257.834c0,.017-1.312.031-2.933.031s-2.937,0-2.937-.031,1.312-.034,2.937-.034S74.43,257.814,74.43,257.834Z",
    transform: "translate(-57.241 -181.992)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M74.43,262.154c0,.02-1.312.034-2.933.034s-2.937,0-2.937-.034,1.312-.034,2.937-.034S74.43,262.137,74.43,262.154Z",
    transform: "translate(-57.241 -184.847)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M74.43,266.484c0,.017-1.312.034-2.933.034s-2.937,0-2.937-.034,1.312-.034,2.937-.034S74.43,266.464,74.43,266.484Z",
    transform: "translate(-57.241 -187.708)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M74.43,270.81c0,.02-1.312.034-2.933.034s-2.937,0-2.937-.034,1.312-.03,2.937-.03S74.43,270.793,74.43,270.81Z",
    transform: "translate(-57.241 -190.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M74.43,276.144c0,.017-1.312.034-2.933.034s-2.937-.017-2.937-.034,1.312-.034,2.937-.034S74.43,276.127,74.43,276.144Z",
    transform: "translate(-57.241 -194.093)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M73.292,291.278c0,.047-2.1.088-4.676.088s-4.676-.041-4.676-.088,2.092-.088,4.676-.088S73.292,291.231,73.292,291.278Z",
    transform: "translate(-54.188 -204.059)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M74.872,294.867a26.137,26.137,0,0,1-3.011.088,26.089,26.089,0,0,1-3.011-.088,26.082,26.082,0,0,1,3.011-.088,26.144,26.144,0,0,1,3.011.088Z",
    transform: "translate(-57.433 -206.424)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M218.718,255.963h-7.555a.939.939,0,0,1-.943-.943V244.576a.943.943,0,0,1,.943-.946h4.788l3.706,3.818v7.575A.943.943,0,0,1,218.718,255.963Z",
    transform: "translate(-150.865 -172.627)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M227.14,243.63v2.94a.878.878,0,0,0,.878.878h2.828Z",
    transform: "translate(-162.047 -172.627)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M227.25,253.06a.977.977,0,0,0,.777.949l.092.02c.37.064,2.8.5,2.8.441v-.79h-2.828S227.386,253.657,227.25,253.06Z",
    transform: "translate(-162.12 -178.859)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M218.7,255.772a1.142,1.142,0,0,0,.163-.017.949.949,0,0,0,.431-.2.933.933,0,0,0,.339-.678v-7.613l-3.717-3.8h-4.551a2.131,2.131,0,0,0-.363,0,.905.905,0,0,0-.59.37.892.892,0,0,0-.17.461v10.3a2.182,2.182,0,0,0,.017.4.916.916,0,0,0,.777.729h.38a3.552,3.552,0,0,1-.376,0,.963.963,0,0,1-.37-.129.976.976,0,0,1-.454-.641,2.349,2.349,0,0,1-.02-.407v-10.3a.956.956,0,0,1,.18-.5.98.98,0,0,1,.634-.4,2.786,2.786,0,0,1,.373,0h4.588l3.7,3.825h0v7.636a.963.963,0,0,1-.339.678.95.95,0,0,1-.437.193.433.433,0,0,1-.122,0Z",
    transform: "translate(-150.848 -172.436)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M230.774,247.442h-.281l-.76.037h-1.814a.9.9,0,0,1-.841-.637,1.112,1.112,0,0,1-.044-.359v-2.791a.286.286,0,0,1,0-.071.289.289,0,0,1,0,.071v2.791a.875.875,0,0,0,.21.644.838.838,0,0,0,.61.285h2.791Z",
    transform: "translate(-161.975 -172.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M218.954,251.3s-.892.034-1.99.034-1.994-.017-1.994-.034.892-.034,1.994-.034S218.954,251.284,218.954,251.3Z",
    transform: "translate(-154.004 -177.676)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M220.843,255.63c0,.02-1.312.034-2.937.034s-2.937,0-2.937-.034,1.316-.031,2.937-.031S220.843,255.613,220.843,255.63Z",
    transform: "translate(-154.004 -180.537)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M220.843,259.934c0,.02-1.312.034-2.937.034s-2.937,0-2.937-.034,1.316-.034,2.937-.034S220.843,259.934,220.843,259.934Z",
    transform: "translate(-154.004 -183.379)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M220.843,264.284s-1.312.03-2.937.03-2.937,0-2.937-.03,1.316-.034,2.937-.034S220.843,264.264,220.843,264.284Z",
    transform: "translate(-154.004 -186.254)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M220.843,268.6c0,.02-1.312.034-2.937.034s-2.937,0-2.937-.034,1.316-.034,2.937-.034S220.843,268.587,220.843,268.6Z",
    transform: "translate(-154.004 -189.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M220.843,273.934c0,.017-1.312.034-2.937.034s-2.937-.017-2.937-.034,1.316-.034,2.937-.034S220.843,273.934,220.843,273.934Z",
    transform: "translate(-154.004 -192.632)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M219.706,289.078c0,.047-2.1.088-4.68.088s-4.676-.041-4.676-.088,2.1-.088,4.676-.088S219.706,289.027,219.706,289.078Z",
    transform: "translate(-150.95 -202.605)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M221.269,292.668a51.39,51.39,0,0,1-6.019,0,51.426,51.426,0,0,1,6.019,0Z",
    transform: "translate(-154.189 -204.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M147,55.918l.339,6.755a.427.427,0,0,0,.393.424h10.417a.427.427,0,0,0,.38-.451V57.386a.427.427,0,0,0-.393-.458l-6.389.064a.37.37,0,0,1-.278-.132l-1.112-1.282a.363.363,0,0,0-.275-.129h-2.713A.431.431,0,0,0,147,55.918Z",
    transform: "translate(-109.078 -48.258)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 11.383,
    height: 7.938,
    transform: "translate(38.074 7.874)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M144.784,58.932l.868,8.288a.275.275,0,0,0,.251.258H157a.271.271,0,0,0,.251-.271l.559-8.281a.281.281,0,0,0-.251-.315H145.035a.281.281,0,0,0-.251.322Z",
    transform: "translate(-107.615 -50.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M159.552,96.958c0,.051-2.092.088-4.676.088s-4.676-.037-4.676-.088,2.092-.088,4.676-.088S159.552,96.914,159.552,96.958Z",
    transform: "translate(-111.197 -75.632)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M161.139,100.548a51.4,51.4,0,0,1-6.019,0,51.412,51.412,0,0,1,6.019,0Z",
    transform: "translate(-114.449 -77.998)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M147.994,149.535l.356,6.755a.424.424,0,0,0,.393.427h10.441a.424.424,0,0,0,.39-.454V151a.424.424,0,0,0-.393-.454l-6.406.047a.37.37,0,0,1-.278-.132l-1.112-1.278a.366.366,0,0,0-.275-.132H148.4a.434.434,0,0,0-.4.485Z",
    transform: "translate(-109.737 -110.118)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 11.383,
    height: 7.938,
    transform: "translate(38.44 39.627)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M145.862,152.569l.871,8.277a.264.264,0,0,0,.248.258h11.1a.268.268,0,0,0,.251-.268l.56-8.281a.281.281,0,0,0-.251-.315H146.113a.281.281,0,0,0-.251.329Z",
    transform: "translate(-108.327 -112.227)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M160.632,190.608c0,.047-2.092.088-4.676.088s-4.676-.041-4.676-.088,2.092-.088,4.676-.088S160.632,190.557,160.632,190.608Z",
    transform: "translate(-111.911 -137.526)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M162.262,194.2a51.466,51.466,0,0,1-6.022,0,51.475,51.475,0,0,1,6.022,0Z",
    transform: "translate(-115.189 -139.889)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M131.783,264.995l.359,6.755a.42.42,0,0,0,.39.427H142.95a.427.427,0,0,0,.393-.454V266.46a.424.424,0,0,0-.393-.454l-6.409.047a.37.37,0,0,1-.278-.132l-1.112-1.278a.366.366,0,0,0-.275-.132h-2.713a.434.434,0,0,0-.38.485Z",
    transform: "translate(-99.023 -186.426)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 11.383,
    height: 7.938,
    transform: "translate(32.933 78.779)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M129.622,268.019l.871,8.281a.265.265,0,0,0,.248.258h11.1a.271.271,0,0,0,.251-.271l.546-8.277a.281.281,0,0,0-.251-.319H129.873a.281.281,0,0,0-.251.329Z",
    transform: "translate(-97.594 -188.528)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M144.392,306.068c0,.047-2.092.088-4.676.088s-4.676-.041-4.676-.088,2.1-.088,4.676-.088S144.392,306.017,144.392,306.068Z",
    transform: "translate(-101.178 -213.834)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M145.972,309.655a26.082,26.082,0,0,1-3.011.088,26.136,26.136,0,0,1-3.011-.088,25.246,25.246,0,0,1,3.011-.088A25.209,25.209,0,0,1,145.972,309.655Z",
    transform: "translate(-104.423 -216.197)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 75.347,
    height: 66.263,
    transform: "translate(70.888 5.799)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M319.425,117.4c0-.627-.031-26.392-.075-66.263l.075.075h-75.34l.088-.088v66.263l-.078-.078,75.347.078-75.347.078H244V51.04h75.51v.075C319.456,91.013,319.425,116.777,319.425,117.4Z",
    transform: "translate(-173.19 -45.343)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M321.433,71.271c0,.031-16.728.058-37.358.058s-37.365-.027-37.365-.058,16.728-.061,37.365-.061S321.433,71.237,321.433,71.271Z",
    transform: "translate(-174.981 -58.674)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M256.336,60.76a.773.773,0,1,1-.773-.76.773.773,0,0,1,.773.76Z",
    transform: "translate(-180.321 -51.265)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M263.826,60.76a.773.773,0,1,1-.773-.76.773.773,0,0,1,.773.76Z",
    transform: "translate(-185.271 -51.265)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M271.316,60.76a.773.773,0,1,1-.773-.76.773.773,0,0,1,.773.76Z",
    transform: "translate(-190.221 -51.265)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M413.8,81.724a.85.85,0,0,0,.125-.024.434.434,0,0,0,.264-.248.631.631,0,0,0,.031-.271v-2.54a.4.4,0,0,0-.39-.366H392.6a.373.373,0,0,0-.376.339v2.553a.489.489,0,0,0,.048.278.387.387,0,0,0,.2.17.455.455,0,0,0,.136.02h13.825l5.4.02h1.98a.95.95,0,0,1-.129,0h-1.851l-5.4.02H392.609a.593.593,0,0,1-.173-.027.512.512,0,0,1-.268-.224.6.6,0,0,1-.064-.339V78.634a.5.5,0,0,1,.5-.454H413.83a.461.461,0,0,1,.448.424v2.547a.678.678,0,0,1-.037.281.437.437,0,0,1-.281.248A.305.305,0,0,1,413.8,81.724Z",
    transform: "translate(-271.07 -63.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M396.3,82.867l.058-.122a.566.566,0,0,0,.366.125c.193,0,.275-.075.275-.17,0-.271-.678-.1-.678-.512,0-.173.132-.319.424-.319a.678.678,0,0,1,.356.1l-.051.129a.56.56,0,0,0-.305-.092c-.19,0-.271.078-.271.176,0,.271.678.1.678.509,0,.17-.136.315-.431.315A.678.678,0,0,1,396.3,82.867Z",
    transform: "translate(-273.845 -65.719)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M400.044,83.191h-.678a.282.282,0,0,0,.305.248.308.308,0,0,0,.241-.1l.085.1a.427.427,0,0,1-.339.136.421.421,0,0,1-.448-.41.414.414,0,0,1,.421-.431.407.407,0,0,1,.417.431A.189.189,0,0,0,400.044,83.191Zm-.678-.109h.539a.265.265,0,0,0-.271-.241.258.258,0,0,0-.271.241Z",
    transform: "translate(-275.768 -66.287)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M402.772,83.022v.509h-.146v-.112a.315.315,0,0,1-.275.119c-.193,0-.312-.1-.312-.248s.088-.244.339-.244h.241v-.031c0-.129-.075-.2-.227-.2a.41.41,0,0,0-.264.092l-.064-.115a.553.553,0,0,1,.339-.109C402.64,82.68,402.772,82.788,402.772,83.022Zm-.153.251v-.119h-.237c-.149,0-.193.058-.193.129s.071.139.187.139a.251.251,0,0,0,.244-.149Z",
    transform: "translate(-277.639 -66.254)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M405.461,82.677v.149h-.034a.251.251,0,0,0-.264.285v.42H405v-.848h.146v.142A.339.339,0,0,1,405.461,82.677Z",
    transform: "translate(-279.595 -66.251)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M406.659,83.125a.424.424,0,0,1,.454-.448.37.37,0,0,1,.339.18l-.115.075a.264.264,0,0,0-.227-.122.3.3,0,0,0,0,.593.258.258,0,0,0,.227-.122l.115.075a.37.37,0,0,1-.339.18.42.42,0,0,1-.454-.41Z",
    transform: "translate(-280.691 -66.252)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M410.33,82.405v.485h-.153v-.468c0-.166-.085-.248-.227-.248a.251.251,0,0,0-.268.281v.434h-.153V81.71h.159v.458a.37.37,0,0,1,.3-.129.339.339,0,0,1,.342.366Z",
    transform: "translate(-282.589 -65.613)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M412.51,84.678a.105.105,0,0,1,.109-.109.109.109,0,1,1,0,.217.105.105,0,0,1-.109-.108Z",
    transform: "translate(-284.559 -67.503)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M413.57,84.679a.109.109,0,1,1,.108.109A.109.109,0,0,1,413.57,84.679Z",
    transform: "translate(-285.259 -67.503)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M414.63,84.679a.109.109,0,1,1,.108.109.108.108,0,0,1-.108-.109Z",
    transform: "translate(-285.96 -67.503)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M381.88,103.327V115.2h14.446V103.327a1.017,1.017,0,0,0-1.017-1.017h-12.4a1.017,1.017,0,0,0-1.027,1.017Z",
    transform: "translate(-264.315 -79.228)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M383.88,112.814l.1-4.364h12.638v2.489",
    transform: "translate(-265.637 -83.286)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 11.044,
    height: 1.18,
    transform: "translate(119.162 23.984)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M386.484,104.914h.841l2.333-.02,7.87-.024h.058v1.224c-.119.119-.037.034-.064.061h-6.633l-4.408-.024h-.024V105a.585.585,0,0,1,0-.075.459.459,0,0,1,0,.081v1.1l-.027-.024,4.408-.024h6.636c-.024.024.064-.061-.054.058v-1.2l.058.061-7.826-.027h-3.157Z",
    transform: "translate(-267.322 -80.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M398.97,149.008c0,.034-2.76.061-6.165.061s-6.165-.027-6.165-.061,2.76-.058,6.165-.058S398.97,148.967,398.97,149.008Z",
    transform: "translate(-267.461 -110.052)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M378.6,113.341l1.109,8.6h14.446v-8.332h-6.558l-1.275-1.119h-6.975a.753.753,0,0,0-.746.851Z",
    transform: "translate(-262.141 -85.956)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M398.987,125.608c0,.034-1.584.061-3.533.061s-3.533-.027-3.533-.061,1.584-.058,3.533-.058S398.987,125.577,398.987,125.608Z",
    transform: "translate(-270.951 -94.587)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M398.987,128.1c0,.034-1.584.058-3.533.058s-3.533-.024-3.533-.058,1.584-.061,3.533-.061S398.987,128.067,398.987,128.1Z",
    transform: "translate(-270.951 -96.233)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M398.931,153.748c0,.034-1.729.061-3.866.061s-3.866-.027-3.866-.061,1.733-.058,3.866-.058S398.931,153.717,398.931,153.748Z",
    transform: "translate(-270.475 -113.185)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M289.23,103.327V115.2h14.446V103.327a1.017,1.017,0,0,0-1.017-1.017h-12.4a1.017,1.017,0,0,0-1.027,1.017Z",
    transform: "translate(-203.082 -79.228)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M291.23,112.814l.1-4.364h12.638v2.489",
    transform: "translate(-204.404 -83.286)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 11.044,
    height: 1.18,
    transform: "translate(87.745 23.984)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M293.834,104.914h.841l2.333-.02,7.87-.024h.058v1.224c-.119.119-.037.034-.064.061h-6.633l-4.408-.024h-.024V105a.585.585,0,0,1,0-.075.465.465,0,0,1,0,.081v1.1l-.027-.024,4.408-.024h6.687c-.024.024.064-.061-.054.058v-1.2l.058.061-7.826-.027H293.9Z",
    transform: "translate(-206.09 -80.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M306.27,149.008c0,.034-2.76.061-6.165.061s-6.165-.027-6.165-.061,2.76-.058,6.165-.058S306.27,148.967,306.27,149.008Z",
    transform: "translate(-206.195 -110.052)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M285.987,113.341l1.109,8.6h14.446v-8.332H294.97L293.7,112.49H286.72a.753.753,0,0,0-.732.851Z",
    transform: "translate(-200.935 -85.956)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M306.337,125.608c0,.034-1.584.061-3.533.061s-3.533-.027-3.533-.061,1.584-.058,3.533-.058S306.337,125.577,306.337,125.608Z",
    transform: "translate(-209.718 -94.587)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M306.337,128.1c0,.034-1.584.058-3.533.058s-3.533-.024-3.533-.058,1.584-.061,3.533-.061S306.337,128.067,306.337,128.1Z",
    transform: "translate(-209.718 -96.233)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M306.3,153.748c0,.034-1.729.061-3.866.061s-3.866-.027-3.866-.061,1.733-.058,3.866-.058S306.3,153.717,306.3,153.748Z",
    transform: "translate(-209.255 -113.185)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M287.9,177.767v11.868h14.442V177.767a1.017,1.017,0,0,0-1.017-1.017h-12.4a1.017,1.017,0,0,0-1.024,1.017Z",
    transform: "translate(-202.203 -128.425)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M289.9,187.254l.095-4.364h12.638v2.489",
    transform: "translate(-203.525 -132.483)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 11.044,
    height: 1.18,
    transform: "translate(87.29 49.227)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M292.494,179.334h.841l2.333-.017,7.87-.027h.061v1.238c-.119.119-.037.034-.064.061H296.9l-4.408-.024h-.027v-1.2a.34.34,0,0,1,0,.078v1.1l-.024-.024,4.408-.024h6.636c-.024.027.064-.058-.054.058v-1.177l.058.058-7.826-.027h-3.218Z",
    transform: "translate(-205.204 -130.104)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M304.97,223.448c0,.034-2.76.061-6.165.061s-6.165-.027-6.165-.061,2.76-.058,6.165-.058S304.97,223.417,304.97,223.448Z",
    transform: "translate(-205.336 -159.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M284.608,187.778l1.112,8.6h14.442v-8.328H293.6l-1.272-1.119h-6.979a.753.753,0,0,0-.746.848Z",
    transform: "translate(-200.024 -135.153)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M305,200.051c0,.03-1.58.058-3.533.058s-3.533-.027-3.533-.058,1.584-.061,3.533-.061S305,200.017,305,200.051Z",
    transform: "translate(-208.832 -143.785)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M305,202.548c0,.034-1.58.058-3.533.058s-3.533-.024-3.533-.058,1.584-.058,3.533-.058S305,202.514,305,202.548Z",
    transform: "translate(-208.832 -145.437)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M304.931,228.188c0,.034-1.729.061-3.866.061s-3.866-.027-3.866-.061,1.733-.058,3.866-.058S304.931,228.157,304.931,228.188Z",
    transform: "translate(-208.35 -162.383)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M381.56,177.767v11.868h14.446V177.767a1.017,1.017,0,0,0-1.017-1.017h-12.4a1.017,1.017,0,0,0-1.024,1.017Z",
    transform: "translate(-264.104 -128.425)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M383.56,187.254l.095-4.364H396.3v2.489",
    transform: "translate(-265.426 -132.483)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 11.044,
    height: 1.18,
    transform: "translate(119.053 49.227)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M386.2,179.334h.838l2.336-.017,7.87-.027h.054v1.238l-.061.061H390.6l-4.408-.024h-.027v-.027c0-.38,0-.678.017-.885v-.292a.693.693,0,0,1,0,.078v1.1l-.024-.024,4.408-.024H397.2c-.027.027.061-.058-.058.058v-1.177l.061.058-7.83-.027h-3.215Z",
    transform: "translate(-267.144 -130.104)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M398.6,223.448c0,.034-2.76.061-6.165.061s-6.165-.027-6.165-.061,2.76-.058,6.165-.058S398.6,223.417,398.6,223.448Z",
    transform: "translate(-267.217 -159.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M378.268,187.778l1.112,8.6h14.446v-8.328h-6.562l-1.272-1.119h-6.979a.753.753,0,0,0-.746.848Z",
    transform: "translate(-261.924 -135.153)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M398.663,200.058c0,.031-1.58.058-3.53.058s-3.533-.027-3.533-.058,1.58-.058,3.527-.058S398.663,200.024,398.663,200.058Z",
    transform: "translate(-270.739 -143.791)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M398.663,202.548c0,.034-1.58.058-3.53.058s-3.533-.024-3.533-.058,1.58-.058,3.533-.058S398.663,202.514,398.663,202.548Z",
    transform: "translate(-270.739 -145.437)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M398.631,228.188c0,.034-1.733.061-3.866.061s-3.866-.027-3.866-.061,1.729-.058,3.866-.058S398.631,228.157,398.631,228.188Z",
    transform: "translate(-270.277 -162.383)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 146.215)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M173.4,465.518c0,.051-33.313.088-74.394.088s-74.4-.037-74.4-.088,33.306-.088,74.4-.088S173.4,465.471,173.4,465.518Z",
    transform: "translate(-24.6 -465.43)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.195 19.473)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M170.3,149.241H143.94L138.9,156.7l-4.913-7.46H108.1a3,3,0,0,1-3-3V94.9a3,3,0,0,1,3-3h62.2a3,3,0,0,1,3,3v51.356A3,3,0,0,1,170.3,149.241Z",
    transform: "translate(-104.998 -91.821)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M170.1,149.087h.163a3.01,3.01,0,0,0,.485-.071,2.977,2.977,0,0,0,2.241-2.218,3.459,3.459,0,0,0,.071-.39,3.424,3.424,0,0,0,0-.417V140.83c0-6.443-.017-15.727-.027-27.213V94.825A2.937,2.937,0,0,0,171,91.963a3.5,3.5,0,0,0-1.265-.142H107.6a3.146,3.146,0,0,0-.39.071,2.886,2.886,0,0,0-2.133,2.14,6.066,6.066,0,0,0-.085,1.455v49.908a6.893,6.893,0,0,0,.054,1.248,2.92,2.92,0,0,0,1.356,1.936,2.835,2.835,0,0,0,1.136.39c.4.041.821.017,1.228.024h25.066l.02.031,4.907,7.46h-.1l5.042-7.46.017-.024h.027l19.451.088h0l-19.434.024.044-.024q-2.34,3.486-5.029,7.477l-.051.078-.051-.078-4.917-7.46.054.031H108.773c-.414,0-.817.017-1.244-.024a3.086,3.086,0,0,1-2.662-2.4,6.78,6.78,0,0,1-.061-1.278V94.774a3.076,3.076,0,0,1,2.353-3.025,3.414,3.414,0,0,1,.414-.075h62.167a3.679,3.679,0,0,1,1.312.153,3.113,3.113,0,0,1,1.133.678,3.052,3.052,0,0,1,.749,1.065,3.225,3.225,0,0,1,.241,1.272v18.793c0,11.485-.02,20.783-.027,27.212v5.161a3.438,3.438,0,0,1-.017.42,2.937,2.937,0,0,1-.071.4,3,3,0,0,1-2.282,2.228,2.763,2.763,0,0,1-.485.058Z",
    transform: "translate(-104.798 -91.667)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 8.037,
    height: 11.119,
    rx: 4.018,
    transform: "translate(11.303 38.716)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 7.82,
    height: 11.119,
    rx: 3.91,
    transform: "translate(30.485 38.716)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 7.82,
    height: 11.119,
    rx: 3.91,
    transform: "translate(21.086 38.716)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 8.04,
    height: 11.119,
    rx: 4.02,
    transform: "translate(39.841 38.716)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 8.04,
    height: 11.119,
    rx: 4.02,
    transform: "translate(49.061 38.716)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M148.36,218.323l.858.465-.387.648-.865-.515v.956h-.739v-.963l-.868.522-.38-.648.861-.465-.861-.475.38-.648.868.522v-.963h.739v.963l.865-.522.387.648Z",
    transform: "translate(-132.015 -174.341)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M176.053,218.186l.861.465-.387.648-.868-.509.017.956h-.743v-.963l-.868.522-.376-.648.858-.465-.858-.475.376-.648.868.522v-.963h.743l-.017.963.868-.522.387.648Z",
    transform: "translate(-150.329 -174.256)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M204.374,218.173l.861.465-.387.648-.885-.509.017.956h-.743v-.963l-.868.522-.37-.654.858-.465L202,217.7l.376-.648.868.522v-.963h.743l-.017.963.868-.522.387.648Z",
    transform: "translate(-169.039 -174.242)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M231.74,218.186l.858.465-.387.648-.868-.509.017.956h-.743v-.963l-.868.522-.38-.648.861-.465-.861-.475.38-.648.868.522v-.963h.743l-.017.963.868-.522.387.648Z",
    transform: "translate(-187.128 -174.256)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M144.227,216.9H140.07a1.943,1.943,0,0,1-1.94-1.94V207.58a1.943,1.943,0,0,1,1.94-1.94h4.157a1.94,1.94,0,0,1,1.94,1.94v7.379a1.943,1.943,0,0,1-1.94,1.94Zm-4.157-11.136a1.8,1.8,0,0,0-1.8,1.8v7.379a1.8,1.8,0,0,0,1.8,1.8h4.157a1.8,1.8,0,0,0,1.8-1.8V207.58a1.807,1.807,0,0,0-1.8-1.8Z",
    transform: "translate(-126.827 -166.992)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M172.7,216.9H168.54a1.943,1.943,0,0,1-1.94-1.94V207.58a1.943,1.943,0,0,1,1.94-1.94H172.7a1.94,1.94,0,0,1,1.936,1.94v7.379a1.94,1.94,0,0,1-1.936,1.94Zm-4.161-11.136a1.8,1.8,0,0,0-1.8,1.8v7.379a1.8,1.8,0,0,0,1.8,1.8H172.7a1.8,1.8,0,0,0,1.8-1.8V207.58a1.8,1.8,0,0,0-1.8-1.8Z",
    transform: "translate(-145.643 -166.992)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M200.384,216.9H196.22a1.943,1.943,0,0,1-1.94-1.94V207.58a1.943,1.943,0,0,1,1.94-1.94h4.161a1.94,1.94,0,0,1,1.936,1.94v7.379a1.94,1.94,0,0,1-1.933,1.94Zm-4.164-11.136a1.8,1.8,0,0,0-1.8,1.8v7.379a1.8,1.8,0,0,0,1.8,1.8h4.161a1.8,1.8,0,0,0,1.8-1.8V207.58a1.8,1.8,0,0,0-1.8-1.8Z",
    transform: "translate(-163.937 -166.992)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M228.384,216.9H224.22a1.943,1.943,0,0,1-1.94-1.94V207.58a1.94,1.94,0,0,1,1.94-1.94h4.157a1.943,1.943,0,0,1,1.94,1.94v7.379A1.943,1.943,0,0,1,228.384,216.9Zm-4.164-11.136a1.807,1.807,0,0,0-1.8,1.8v7.379a1.8,1.8,0,0,0,1.8,1.8h4.157a1.8,1.8,0,0,0,1.8-1.8V207.58a1.8,1.8,0,0,0-1.8-1.8Z",
    transform: "translate(-182.442 -166.992)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M255.587,216.9H251.43a1.943,1.943,0,0,1-1.94-1.94V207.58a1.94,1.94,0,0,1,1.94-1.94h4.157a1.943,1.943,0,0,1,1.94,1.94v7.379A1.943,1.943,0,0,1,255.587,216.9Zm-4.157-11.136a1.807,1.807,0,0,0-1.8,1.8v7.379a1.8,1.8,0,0,0,1.8,1.8h4.157a1.8,1.8,0,0,0,1.8-1.8V207.58a1.8,1.8,0,0,0-1.8-1.8Z",
    transform: "translate(-200.425 -166.992)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M259.226,229.938a28.193,28.193,0,0,1-4.456,0,28.193,28.193,0,0,1,4.456,0Z",
    transform: "translate(-203.915 -182.985)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 8.983,
    cy: 8.983,
    r: 8.983,
    transform: "translate(25.176 9.386)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.429 13.933)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M201.786,135.33h-.149v-.838a1.753,1.753,0,1,1,3.5,0v.678h-.149v-.678a1.6,1.6,0,1,0-3.2,0Z",
    transform: "translate(-200.402 -132.663)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M203.192,146.241h-4.452A.736.736,0,0,1,198,145.5v-4.452a.739.739,0,0,1,.739-.739h4.452a.743.743,0,0,1,.739.739V145.5A.739.739,0,0,1,203.192,146.241Zm-4.452-5.782a.59.59,0,0,0-.59.59V145.5a.59.59,0,0,0,.59.59h4.452a.59.59,0,0,0,.59-.59v-4.452a.59.59,0,0,0-.59-.59Z",
    transform: "translate(-198 -137.717)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M205.435,146.754a.7.7,0,1,1,.7-.7.7.7,0,0,1-.7.7Zm0-1.248a.546.546,0,1,0,.389.16A.549.549,0,0,0,205.435,145.506Z",
    transform: "translate(-202.448 -141.048)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 0.149,
    height: 1.261,
    transform: "translate(2.889 5.597)"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2.774,
    cy: 2.774,
    r: 2.774,
    transform: "translate(58.968 7.285) rotate(-77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M285.641,105.993a.085.085,0,0,1-.061-.027.081.081,0,0,1,0-.119l1.8-1.8a.081.081,0,0,1,.119,0,.085.085,0,0,1,0,.122l-1.8,1.794A.085.085,0,0,1,285.641,105.993Z",
    transform: "translate(-224.26 -99.834)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M287.434,105.993a.085.085,0,0,1-.058-.027l-1.8-1.794a.085.085,0,0,1,0-.122.081.081,0,0,1,.119,0l1.8,1.8a.081.081,0,0,1,0,.119A.085.085,0,0,1,287.434,105.993Z",
    transform: "translate(-224.26 -99.834)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "k",
    transform: "translate(30.924 33.416)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.804,
    y: 0
  }, "Insira sua senha"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.631 89.434)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M49.806,357.482s-8.959-10.312-12.34-20.624-1.777-9.128-1.777-9.128,4.564,10.017,8.03,14.856,9.637,11.936,9.637,11.936Z",
    transform: "translate(-35.309 -317.615)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M81.417,332.025a.522.522,0,0,0-.97.339A138,138,0,0,1,82.143,350c-.058,7.162,0,9.929,0,9.929h3.73s-.678-14.8-1.506-19.328A31.428,31.428,0,0,0,81.417,332.025Z",
    transform: "translate(-65.137 -320.307)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M89.32,356.229A39.488,39.488,0,0,0,92.389,345.1c.305-2.635-.241-6.2-1.055-10.953a29.24,29.24,0,0,1-.471-5.27.888.888,0,0,1,1.668-.417,23.712,23.712,0,0,1,2.085,5.266c.9,4.693,1.923,7.04,1.143,11.5s-3.672,11.312-3.672,11.312Z",
    transform: "translate(-71.005 -317.818)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M99.22,345.406s9.834-21.139,10.512-24.276,3-10.363,3.272-9.952.678,4.225-1.089,8.589-9.342,26.283-9.342,26.283H99.22",
    transform: "translate(-77.548 -306.692)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M52.8,355.913a1.751,1.751,0,0,1-.275-.19c-.176-.132-.441-.319-.763-.58-.654-.515-1.573-1.3-2.645-2.333A44.424,44.424,0,0,1,42,343.654,60.085,60.085,0,0,1,37.128,333.1c-.5-1.4-.855-2.553-1.089-3.35-.122-.4-.2-.712-.261-.922a1.981,1.981,0,0,1-.078-.339,1.94,1.94,0,0,1,.119.312c.075.227.173.532.3.912.258.79.641,1.929,1.15,3.326a64.111,64.111,0,0,0,4.914,10.5,46.457,46.457,0,0,0,7.06,9.156c1.055,1.048,1.953,1.845,2.591,2.374.315.271.573.468.736.61a2.068,2.068,0,0,1,.237.237Z",
    transform: "translate(-35.567 -318.145)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M84.4,348.863a2.975,2.975,0,0,1-.088-.621c-.047-.437-.109-1.017-.183-1.7-.156-1.431-.4-3.391-.746-5.571s-.736-4.117-1.038-5.52c-.146-.678-.264-1.238-.359-1.668a3.445,3.445,0,0,1-.109-.617,3.636,3.636,0,0,1,.19.6c.109.39.254.953.424,1.655.339,1.4.749,3.35,1.1,5.524s.57,4.151.678,5.588c.058.715.1,1.3.115,1.7a3.816,3.816,0,0,1,.017.634Z",
    transform: "translate(-66.088 -321.238)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M94.174,328.87a1.314,1.314,0,0,1,.115.268l.3.787c.132.339.281.76.424,1.258s.339,1.055.478,1.7l.244.994c.081.339.139.712.214,1.089.163.749.261,1.563.38,2.418a35.943,35.943,0,0,1-.4,11.177c-.18.841-.339,1.648-.549,2.374-.105.37-.19.732-.3,1.072l-.315.99c-.186.624-.417,1.17-.6,1.655a10.82,10.82,0,0,1-.512,1.224l-.339.763a1.333,1.333,0,0,1-.136.258,1.543,1.543,0,0,1,.095-.275c.081-.2.187-.454.315-.777s.309-.746.475-1.238.39-1.017.57-1.658c.095-.309.193-.634.3-.973s.183-.7.281-1.068c.2-.736.339-1.536.529-2.374a37.267,37.267,0,0,0,.4-11.116c-.115-.851-.207-1.662-.359-2.411-.071-.373-.125-.739-.2-1.085s-.156-.678-.231-.994c-.132-.634-.312-1.194-.444-1.7s-.271-.922-.39-1.268l-.254-.8a1.539,1.539,0,0,1-.088-.292Z",
    transform: "translate(-73.556 -318.396)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M116.038,312.46a.4.4,0,0,1,0,.095,2.356,2.356,0,0,1-.044.275c-.044.241-.1.6-.193,1.051a38.2,38.2,0,0,1-1.017,3.8c-.509,1.587-1.16,3.452-1.957,5.5s-1.716,4.276-2.591,6.65-1.57,4.683-2.211,6.782-1.241,3.984-1.824,5.541a35.168,35.168,0,0,1-1.543,3.618c-.2.417-.383.729-.5.946l-.139.241c-.031.054-.047.081-.051.078a.285.285,0,0,1,.034-.088l.119-.251c.105-.22.275-.539.465-.963.393-.838.929-2.068,1.485-3.632s1.153-3.442,1.777-5.544,1.312-4.408,2.2-6.782,1.8-4.608,2.608-6.65,1.489-3.889,2-5.47.844-2.876,1.058-3.778c.109-.451.176-.8.234-1.044.024-.109.047-.2.064-.268A.309.309,0,0,1,116.038,312.46Z",
    transform: "translate(-80.687 -307.551)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M47.316,298.223a.844.844,0,0,0-1.394.861,24.128,24.128,0,0,0,1.234,3.181c1.356,2.872,5.324,13.184,7.185,18.847s4.466,16.229,4.466,16.229l3.971-.644s-3.632-17.345-7.169-23.615C52.758,308.057,49.9,300.793,47.316,298.223Z",
    transform: "translate(-42.297 -297.983)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M74,376.64a2.221,2.221,0,0,1,.207.475c.115.312.278.766.458,1.333.366,1.133.814,2.713,1.261,4.473s.827,3.36,1.089,4.52c.119.546.217,1.017.3,1.373a2.623,2.623,0,0,1,.081.512,2.54,2.54,0,0,1-.163-.492c-.095-.363-.217-.817-.363-1.356-.305-1.194-.7-2.764-1.146-4.5s-.871-3.344-1.2-4.483c-.156-.539-.288-.99-.393-1.356A2.586,2.586,0,0,1,74,376.64Z",
    transform: "translate(-60.88 -349.968)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M61.706,337.354a.42.42,0,0,1-.02-.105,2.352,2.352,0,0,0-.047-.312c-.041-.275-.078-.678-.163-1.2-.146-1.044-.4-2.547-.831-4.381a63.219,63.219,0,0,0-1.858-6.341c-.817-2.353-1.838-4.9-2.994-7.528-2.336-5.253-4.669-9.915-6.205-13.36-.773-1.723-1.356-3.123-1.77-4.1-.2-.488-.339-.871-.444-1.129-.047-.119-.081-.217-.112-.3a.384.384,0,0,1-.031-.105.457.457,0,0,1,.051.095l.129.288c.119.271.278.644.485,1.116.417.966,1.038,2.374,1.828,4.069,1.567,3.421,3.923,8.077,6.263,13.34,1.156,2.635,2.177,5.185,2.984,7.548a60.019,60.019,0,0,1,1.821,6.375,44.154,44.154,0,0,1,.766,4.408c.071.522.095.933.125,1.207l.024.315A.442.442,0,0,1,61.706,337.354Z",
    transform: "translate(-43.188 -298.318)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M87.277,379.633a4.357,4.357,0,0,1-.136-.678c-.078-.465-.183-1.082-.309-1.824-.271-1.539-.678-3.659-1.292-5.965s-1.265-4.351-1.78-5.826c-.251-.712-.461-1.3-.621-1.743a4.209,4.209,0,0,1-.21-.648,4.071,4.071,0,0,1,.288.617c.17.4.41.99.678,1.723a57.654,57.654,0,0,1,1.845,5.836,60.5,60.5,0,0,1,1.238,5.992c.112.773.2,1.4.241,1.838a4.527,4.527,0,0,1,.058.678Z",
    transform: "translate(-66.782 -340.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 15.5,
    height: 18.884,
    transform: "translate(13.147 38.144)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "n",
    transform: "translate(13.147 38.144)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "o",
    width: 15.5,
    height: 18.884,
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 13.75,
    height: 18.884,
    transform: "translate(9.95 38.144)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.194 40.568)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M330.343,284.27l-8.148-1.18-16.3,2.411-4.574,1.617.81,10,15.673,2.886,10.573-3.133,4-5.883Z",
    transform: "translate(-247.679 -239.274)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M321.278,286.257l-6.823-1.607s-4.819,14.92-16.718,14.266c-9.7-.526-9.81-11.35-9.81-11.35l-6.989,2.238s-2.676,17.928.285,30.631c.678,2.967,1.617,6.965,1.617,6.965l-.946,18.559,51.692.081Z",
    transform: "translate(-233.476 -240.305)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "r",
    transform: "translate(67.537 97.702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.3,446.351c2.516-.064,4.836.149,7.352.088a48.485,48.485,0,0,1,9.04.339c2.231.37,4.408,1.048,6.639,1.4a14.3,14.3,0,0,0,9.017-1.156l-.437-2.533L363.609,442Z",
    transform: "translate(-342.3 -442)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M241.575,303.743a14.7,14.7,0,0,1,6.294-4.323l2.645,23.021-5.008,33.523-16.406-.078S238.147,308.169,241.575,303.743Z",
    transform: "translate(-199.948 -250.066)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M394.077,288.89s11.041.885,15,18.989c1.79,8.182,4.069,17.769,4.71,24.215.471,4.673-2.068,11.99-6.728,12.591l-5.86.787a9.682,9.682,0,0,1-3.452-.125c-3.7-.851-4.069-3.391-4.747-6.1l-1.7-5.4c-.936-5.134,3.849-6.1,6.49-6.033l-1.97-23.435Z",
    transform: "translate(-307.072 -243.107)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M279.458,337.17a1.2,1.2,0,0,0-.051.251c-.027.183-.064.427-.112.729-.02.159-.047.339-.075.529s-.041.4-.064.631c-.047.451-.1.966-.125,1.539a38.91,38.91,0,0,0-.027,4.025,49.138,49.138,0,0,0,.488,4.9c.254,1.733.573,3.367.9,4.846s.641,2.8.919,3.916.512,2,.678,2.621c.081.3.146.532.2.709a1.2,1.2,0,0,0,.081.244,1.261,1.261,0,0,0-.047-.251c-.041-.183-.095-.421-.163-.719-.153-.641-.366-1.536-.631-2.635s-.57-2.441-.878-3.92-.631-3.11-.882-4.836-.427-3.391-.5-4.886a34.961,34.961,0,0,1,0-4.008c.017-.573.061-1.085.1-1.539q.024-.339.051-.631c.02-.19.041-.366.058-.529.034-.3.061-.546.078-.732A1.3,1.3,0,0,0,279.458,337.17Z",
    transform: "translate(-232.904 -275.016)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M419.251,409.85a1.987,1.987,0,0,0-.078-.465,7.4,7.4,0,0,0-.427-1.19,8.114,8.114,0,0,0-6.48-4.717,7.115,7.115,0,0,0-1.265-.041,2.067,2.067,0,0,0-.461.058,15.137,15.137,0,0,1,1.7.105,8.372,8.372,0,0,1,6.385,4.646,16.462,16.462,0,0,1,.631,1.6Z",
    transform: "translate(-319.863 -318.804)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M416.806,395.74a.85.85,0,0,0-.268-.024,5.626,5.626,0,0,0-.729.034,8.366,8.366,0,0,0-2.33.583,8.563,8.563,0,0,0-2.068,1.224,5.9,5.9,0,0,0-.539.488c-.119.125-.18.2-.173.207s.3-.237.79-.6a9.737,9.737,0,0,1,4.337-1.784C416.426,395.784,416.806,395.77,416.806,395.74Z",
    transform: "translate(-319.967 -313.707)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M394.9,304a2.5,2.5,0,0,0,.027-.485c0-.312.02-.76.058-1.312a21.072,21.072,0,0,1,2.326-8.281c.254-.492.475-.885.634-1.15a2.506,2.506,0,0,0,.227-.427,2.559,2.559,0,0,0-.288.39,13.168,13.168,0,0,0-.678,1.129,19.1,19.1,0,0,0-2.34,8.335c-.02.556-.02,1.017,0,1.319A2.34,2.34,0,0,0,394.9,304Z",
    transform: "translate(-309.496 -245.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M332.64,375.15a.738.738,0,0,0,.047.19c.041.122.092.309.183.532a11.052,11.052,0,0,0,.919,1.862,11.967,11.967,0,0,0,11.723,5.629,11.42,11.42,0,0,0,2.035-.444c.234-.071.41-.149.529-.193a1.016,1.016,0,0,0,.18-.078c0-.017-.261.071-.729.2a12.29,12.29,0,0,1-13.635-5.181,12.857,12.857,0,0,1-.963-1.821A4.584,4.584,0,0,0,332.64,375.15Z",
    transform: "translate(-268.378 -300.116)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M401.26,441.582c.017-.017.19.231.6.57a5.542,5.542,0,0,0,2.035.963,10.69,10.69,0,0,0,3.323.3c1.261-.091,2.655-.241,4.1-.454a21.021,21.021,0,0,0,4-.922,5.085,5.085,0,0,0,1.468-.98,7.629,7.629,0,0,0,1.017-1.17,11.062,11.062,0,0,0,1.129-1.957c.105-.248.186-.437.237-.57a.773.773,0,0,1,.088-.2,1.385,1.385,0,0,1-.054.207c-.041.139-.112.339-.21.587a9.911,9.911,0,0,1-1.089,2,7.581,7.581,0,0,1-1.017,1.2,5.127,5.127,0,0,1-1.506,1.017,19.937,19.937,0,0,1-4.035.946c-1.455.217-2.845.359-4.117.444a10.68,10.68,0,0,1-3.367-.339,5.427,5.427,0,0,1-2.035-1.017,3.254,3.254,0,0,1-.431-.451A.89.89,0,0,1,401.26,441.582Z",
    transform: "translate(-313.729 -341.099)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M395.887,343.72c.044,0,1.211,4.507,2.6,10.095s2.475,10.126,2.428,10.139-1.211-4.51-2.6-10.1S395.84,343.73,395.887,343.72Z",
    transform: "translate(-310.177 -279.344)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M391.563,408.722a1.384,1.384,0,0,1-.058-.373,6.645,6.645,0,0,1-.024-1.017,3.014,3.014,0,0,1,.5-1.448,4.3,4.3,0,0,1,.566-.712,3.987,3.987,0,0,1,.783-.583,9.928,9.928,0,0,1,3.215-1.038,9.032,9.032,0,0,1,1.017-.088,1.28,1.28,0,0,1,.376,0c0,.027-.532.047-1.377.2a10.707,10.707,0,0,0-3.147,1.065,3.932,3.932,0,0,0-.753.556,4.257,4.257,0,0,0-.549.678,2.92,2.92,0,0,0-.509,1.356,8.667,8.667,0,0,0-.03,1.017,1.675,1.675,0,0,1-.01.387Z",
    transform: "translate(-307.261 -318.82)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "r",
    transform: "translate(44.87 61.419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.646,350.938a17.038,17.038,0,0,1-.42-15.938,44.68,44.68,0,0,0,.5,15.917",
    transform: "translate(-275.453 -335)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M325.89,417.08h.02Z",
    transform: "translate(-263.917 -327.828)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M326.25,417.25l.044.02Z",
    transform: "translate(-264.155 -327.941)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M326,417.11l.1.047Z",
    transform: "translate(-263.99 -327.848)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M325.76,417l.044.02Z",
    transform: "translate(-263.831 -327.776)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M294.286,424.8c.888-1.675,7.816-6.1,7.816-6.1l-1.875-.434-2.072.875a5.087,5.087,0,0,1-.892,1.94c-.76,1.085-2.052-.037-2.052-.037l.875-4.195,4.1-2.465a40.091,40.091,0,0,1,4.476.888l1.641,1.5c.722.566,2.8,2.794,3.374,2.862s18.464-3.95,18.464-3.95h0c2.452,1.943,3.73,5.8,4.13,8.583a3.08,3.08,0,0,1-.037,2.109l-21.95,1.723-4.652,1.285a32.924,32.924,0,0,1-3.822,1.312c-1.546.339-2.587-.173-2.631-1.017s1.16-.949,1.16-.949a23.392,23.392,0,0,0,2.991-1.316,5.245,5.245,0,0,0,1.7-1.851l-1.658.2s-3.527,2.448-4.852,3.167-1.587-.6-1.7-1.017,3.961-4.378,3.961-4.378-3.869,2.374-4.564,2.984-1.726.783-1.946.38S293.4,426.476,294.286,424.8Z",
    transform: "translate(-242.73 -326.044)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M326.38,417.31l.037.02Z",
    transform: "translate(-264.241 -327.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M326.56,417.4Z",
    transform: "translate(-264.36 -328.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M326.49,417.37h.024Z",
    transform: "translate(-264.314 -328.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M344.233,435.438a.954.954,0,0,0,.02-.271,1.589,1.589,0,0,0-.02-.319,2.4,2.4,0,0,0-.078-.417,5.955,5.955,0,0,0-1.122-2.167,12.547,12.547,0,0,0-1.7-1.757,4.872,4.872,0,0,0-.8-.617,8.557,8.557,0,0,0,.719.7,16.165,16.165,0,0,1,1.641,1.773,6.379,6.379,0,0,1,1.139,2.1C344.216,435.051,344.2,435.441,344.233,435.438Z",
    transform: "translate(-273.599 -336.294)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M318.69,425.3a2.543,2.543,0,0,0,2.187-.736c-.027-.037-.451.278-1.058.475S318.69,425.252,318.69,425.3Z",
    transform: "translate(-259.159 -332.773)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M315.29,437.5a21.821,21.821,0,0,0,3.466-1.424,10.592,10.592,0,0,0-1.763.637A11.055,11.055,0,0,0,315.29,437.5Z",
    transform: "translate(-256.911 -340.385)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M326.25,445.839a4.07,4.07,0,0,0,.9-.322,3.988,3.988,0,0,0,.882-.376A3.567,3.567,0,0,0,326.25,445.839Z",
    transform: "translate(-264.155 -346.373)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M317,441.165a3.839,3.839,0,0,1,.678.6,3.761,3.761,0,0,1,.393.821c.02,0,.041-.112,0-.288a1.469,1.469,0,0,0-.278-.631,1.451,1.451,0,0,0-.532-.434C317.109,441.155,317,441.148,317,441.165Z",
    transform: "translate(-258.042 -343.741)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M312.177,433.613c-.024.041.281.207.482.556a4.412,4.412,0,0,1,.248.7.824.824,0,0,0-.112-.787C312.567,433.684,312.184,433.569,312.177,433.613Z",
    transform: "translate(-254.854 -338.749)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M313.066,417.195c.02,0,.081-.068.132-.22a1.2,1.2,0,0,0,0-.61,1.18,1.18,0,0,0-.292-.536c-.112-.112-.2-.153-.217-.136a3.2,3.2,0,0,1,.339.712A2.923,2.923,0,0,1,313.066,417.195Z",
    transform: "translate(-255.193 -326.909)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M398.808,429.05a3.149,3.149,0,0,1-.027-.505,5.5,5.5,0,0,0-.024-.59c-.024-.231-.02-.492-.054-.777a17.4,17.4,0,0,0-.96-4.408,15.8,15.8,0,0,0-1.038-2.252c-.2-.339-.38-.641-.583-.915-.095-.139-.19-.271-.281-.4a2.984,2.984,0,0,0-.281-.339c-.729-.9-1.289-1.356-1.261-1.384a2.312,2.312,0,0,1,.393.315,5.012,5.012,0,0,1,.434.41c.159.166.339.339.532.576.092.115.19.231.292.339a4.54,4.54,0,0,1,.3.4c.21.275.393.593.6.919a14.727,14.727,0,0,1,1.065,2.272,16.147,16.147,0,0,1,.919,4.449c.024.288.02.553.027.783s0,.431,0,.593A2.532,2.532,0,0,1,398.808,429.05Z",
    transform: "translate(-309.128 -328.093)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "r",
    transform: "translate(90.708 84.439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.134,403.723a11.027,11.027,0,0,0-6.5-.593h0a9,9,0,0,1,8.779,5.676c.156.42.468.919.916.855s.57-.583.57-1C420.9,406.466,419.158,404.567,417.134,403.723Z",
    transform: "translate(-410.63 -402.888)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M267.811,323.614a1.064,1.064,0,0,1-.292-.1c-.187-.071-.448-.19-.766-.339a16.057,16.057,0,0,1-2.374-1.455,16.27,16.27,0,0,1-2.082-1.831c-.244-.258-.437-.475-.56-.627s-.19-.244-.18-.254.319.305.827.794a21.54,21.54,0,0,0,2.1,1.78,21.167,21.167,0,0,0,2.316,1.482C267.438,323.414,267.831,323.591,267.811,323.614Z",
    transform: "translate(-221.399 -263.013)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M319.387,336.359a.383.383,0,0,1-.085.058l-.261.156c-.227.139-.573.339-1.017.563a28.483,28.483,0,0,1-3.95,1.665,38.032,38.032,0,0,1-6.182,1.485,60,60,0,0,1-7.759.644c-2.764.064-5.4,0-7.8-.041a51.95,51.95,0,0,1-6.341-.478,24.6,24.6,0,0,1-4.178-.97c-.478-.163-.848-.3-1.092-.4l-.278-.119a.5.5,0,0,1-.095-.044l.1.027.285.1c.248.095.621.22,1.1.373a26.823,26.823,0,0,0,4.171.912,54.576,54.576,0,0,0,6.328.437c2.374.044,5.019.092,7.775.027a60.947,60.947,0,0,0,7.738-.631,38.682,38.682,0,0,0,6.168-1.441,30.7,30.7,0,0,0,3.961-1.607c.451-.224.8-.4,1.017-.532l.268-.139A.64.64,0,0,1,319.387,336.359Z",
    transform: "translate(-233.82 -274.479)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M260,365.906a1.871,1.871,0,0,1-.42-.088l-1.129-.309c-.949-.268-2.258-.651-3.7-1.082s-2.747-.834-3.689-1.133l-1.112-.359a2.34,2.34,0,0,1-.4-.156,1.87,1.87,0,0,1,.421.088l1.129.309c.949.268,2.258.651,3.7,1.082s2.747.831,3.689,1.129l1.112.363A2.037,2.037,0,0,1,260,365.906Z",
    transform: "translate(-213.464 -291.941)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M253.913,418.477c0,.044-3.391-.926-7.562-2.17s-7.525-2.292-7.511-2.34,3.391.922,7.562,2.17S253.926,418.429,253.913,418.477Z",
    transform: "translate(-206.385 -325.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M406.8,307.69a2.346,2.346,0,0,1-.373.3c-.244.18-.61.431-1.068.729a36.39,36.39,0,0,1-7.653,3.761c-.515.18-.936.315-1.231.4a2.286,2.286,0,0,1-.461.115,2.622,2.622,0,0,1,.441-.18l1.211-.451c1.017-.39,2.411-.966,3.9-1.7s2.8-1.482,3.73-2.052l1.1-.678A2.4,2.4,0,0,1,406.8,307.69Z",
    transform: "translate(-310.26 -255.532)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M418.376,364.51a4.2,4.2,0,0,1-.549.261c-.356.159-.885.37-1.543.61a35.83,35.83,0,0,1-10.705,2.13c-.7.031-1.268.037-1.662.024a4.541,4.541,0,0,1-.607-.027,3.653,3.653,0,0,1,.607-.041c.39,0,.956-.034,1.655-.081a41.578,41.578,0,0,0,5.409-.7,42.189,42.189,0,0,0,5.266-1.417c.661-.227,1.194-.42,1.56-.559A3.525,3.525,0,0,1,418.376,364.51Z",
    transform: "translate(-315.084 -293.085)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M410.745,421.36a.731.731,0,0,1,.017-.19c.02-.139.051-.315.085-.532s.085-.515.119-.848.092-.705.105-1.126c0-.207.027-.427.041-.654s0-.468,0-.712c0-.492-.02-1.017-.047-1.57a23.02,23.02,0,0,0-.546-3.554,23.293,23.293,0,0,0-1.129-3.415c-.231-.5-.437-.987-.678-1.417-.115-.217-.22-.431-.339-.631l-.339-.563c-.207-.366-.431-.678-.61-.953a8.472,8.472,0,0,0-.492-.7l-.319-.437a.71.71,0,0,1-.1-.159,1.016,1.016,0,0,1,.129.136l.339.421a8.15,8.15,0,0,1,.519.678c.19.275.42.58.634.943l.339.563c.119.2.227.414.339.631a14.594,14.594,0,0,1,.678,1.421,20.477,20.477,0,0,1,1.7,7.023c.02.556.051,1.085.03,1.58,0,.247,0,.488-.02.719s-.034.448-.051.658c-.024.424-.092.8-.136,1.129s-.095.617-.146.844-.088.39-.119.532A.843.843,0,0,1,410.745,421.36Z",
    transform: "translate(-317.199 -319.118)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M427.04,409.366c-.017,0-.027-.278-.105-.766a6.591,6.591,0,0,0-.678-1.974,8.315,8.315,0,0,0-1.916-2.414,9.95,9.95,0,0,0-3.259-1.906,12.7,12.7,0,0,0-3.733-.651,23.663,23.663,0,0,0-3.113.119c-.885.081-1.6.173-2.1.227l-.57.061a.742.742,0,0,1-.2,0,.765.765,0,0,1,.193-.044l.566-.1c.492-.078,1.207-.183,2.092-.285a22.774,22.774,0,0,1,3.133-.156,12.726,12.726,0,0,1,3.784.654,10.031,10.031,0,0,1,3.31,1.953,8.244,8.244,0,0,1,1.919,2.479,6.236,6.236,0,0,1,.621,2.035,4.236,4.236,0,0,1,.041.577A.831.831,0,0,1,427.04,409.366Z",
    transform: "translate(-320.411 -317.517)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M312.937,395.79a.8.8,0,0,1-.193.034l-.553.058-2.035.169c-1.719.132-4.1.3-6.721.431s-5.008.22-6.734.241h-2.587a.708.708,0,0,1-.193-.02.842.842,0,0,1,.193-.017h.553l2.035-.051c1.719-.051,4.1-.153,6.724-.292l6.721-.38,2.035-.115.556-.024a.772.772,0,0,1,.2-.034Z",
    transform: "translate(-242.788 -313.758)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "r",
    transform: "translate(66.344 78.831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.555,390.256a12.47,12.47,0,0,0,7.179,0,6.955,6.955,0,0,1-7.5,2.4,7.717,7.717,0,0,1-5.453-6.307A11.793,11.793,0,0,0,344.555,390.256Z",
    transform: "translate(-338.78 -386.35)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M373.425,391.278a1.063,1.063,0,0,1-.173.047l-.492.105c-.431.088-1.051.2-1.824.339-1.543.271-3.683.6-6.053.9s-4.53.482-6.1.59c-.78.054-1.414.092-1.851.108l-.5.017a.549.549,0,0,1-.176,0,.9.9,0,0,1,.173-.027l.5-.051,1.845-.166c1.56-.139,3.71-.339,6.083-.641s4.507-.6,6.053-.841l1.831-.285.5-.071A.536.536,0,0,1,373.425,391.278Z",
    transform: "translate(-283.982 -310.775)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "r",
    transform: "translate(85.787 65.406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.221,346.76c-.536,6.138,1.136,12.228,2.794,18.162a2.523,2.523,0,0,0,.454,1.017.882.882,0,0,0,1.017.281c.519-.264.448-1.017.3-1.573l-4.608-17.633",
    transform: "translate(-396.119 -346.76)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M143.168,361.7l6.968,34.215h60.495a1.207,1.207,0,0,0,1.207-1.207h0a1.207,1.207,0,0,0-1.207-1.207h-12.18l-6.46-31.821a1.323,1.323,0,0,0-1.282-1.058l-46.232-.505a1.319,1.319,0,0,0-1.309,1.584Z",
    transform: "translate(-143.138 -290.183)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M143.161,361.665a.812.812,0,0,1-.02-.1,1.251,1.251,0,0,1,0-.312,1.356,1.356,0,0,1,.641-1,1.31,1.31,0,0,1,.4-.156,1.987,1.987,0,0,1,.475-.031h1.089l2.713.024,17.48.166,12.187.122,6.829.071,3.581.037,1.828.017h.468a1.33,1.33,0,0,1,.468.136,1.384,1.384,0,0,1,.678.7,2.15,2.15,0,0,1,.125.465l.095.461c.061.305.125.614.186.922.129.621.254,1.244.383,1.868l.773,3.808q.783,3.849,1.6,7.877c1.092,5.365,2.228,10.943,3.391,16.694l-.081-.068h11.977a2.249,2.249,0,0,1,.471.027,1.309,1.309,0,0,1,.787.563,1.3,1.3,0,0,1-.448,1.872,1.276,1.276,0,0,1-.57.153h-60.59v-.051c-2.133-10.512-3.866-19.071-5.066-25-.593-2.964-1.058-5.27-1.373-6.836-.156-.783-.275-1.38-.339-1.784s-.112-.61-.112-.61.048.207.132.607l.373,1.777c.322,1.567.8,3.873,1.407,6.829l5.12,24.991-.064-.054h60.536a1.16,1.16,0,0,0,.5-.132,1.129,1.129,0,0,0,.387-1.631,1.106,1.106,0,0,0-.678-.458,2.279,2.279,0,0,0-.437-.027H198.376v-.064q-1.75-8.647-3.391-16.7-.817-4.022-1.6-7.877l-.793-3.859c-.125-.627-.251-1.248-.376-1.868-.064-.309-.125-.617-.19-.926l-.092-.458a1.926,1.926,0,0,0-.119-.437,1.238,1.238,0,0,0-.58-.624,1.262,1.262,0,0,0-.417-.122h-.454l-1.831-.02-3.581-.041-6.826-.081-12.187-.142-17.48-.214-2.713-.037-1.089-.017a2.1,2.1,0,0,0-.468.024,1.376,1.376,0,0,0-.39.153,1.319,1.319,0,0,0-.641.977A1.577,1.577,0,0,0,143.161,361.665Z",
    transform: "translate(-143.131 -290.144)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M7.2,4.12a3.886,3.886,0,0,1-3.6,4.12A3.886,3.886,0,0,1,0,4.12,3.886,3.886,0,0,1,3.6,0,3.886,3.886,0,0,1,7.2,4.12Z",
    transform: "translate(21.93 86.17) rotate(-23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M143.38,365.61h3.174l8.65.041,28.535.2,4.127.034h1.017a2.478,2.478,0,0,1,.519.031,1.4,1.4,0,0,1,.488.2,1.421,1.421,0,0,1,.614.834c.078.339.132.651.2.977.512,2.577,1.017,5.063,1.475,7.43.936,4.747,1.78,9,2.486,12.587l1.665,8.477c.19,1,.339,1.777.444,2.309.047.261.085.461.112.6a1.791,1.791,0,0,1,.031.2s-.02-.068-.047-.2-.075-.339-.129-.6c-.109-.532-.268-1.306-.475-2.3-.407-2.007-.99-4.9-1.716-8.477l-2.523-12.58q-.707-3.561-1.482-7.43c-.068-.319-.129-.651-.2-.963a1.271,1.271,0,0,0-.546-.736,1.249,1.249,0,0,0-.434-.163,2.261,2.261,0,0,0-.485-.027h-1.017l-4.127-.031-28.538-.251-8.647-.095-2.353-.034h-.61Z",
    transform: "translate(-143.296 -293.812)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M361.466,212.37a22.414,22.414,0,0,1-7.148,16.911q-1.6-4.629-3.2-9.257",
    transform: "translate(-280.592 -192.535)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M300.551,155.3a13.574,13.574,0,0,1,9.122-1.1,28.727,28.727,0,0,1,8.627,3.567,14.13,14.13,0,0,1,4.123,3.215c1.991,2.506,3.961,6.623,4.151,9.834.156,2.584-.834,9.05-1.926,11.4-1,2.153-5.69,3.794-8.006,4.327L295.4,161.815A10.763,10.763,0,0,1,300.551,155.3Z",
    transform: "translate(-243.766 -153.876)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M287.988,166.119l5.086-.909c-2.784,6.629-3.54,21.787-5.13,28.8-1.879-2.713-6.236-11.021-6-14.32S281.956,165.559,287.988,166.119Z",
    transform: "translate(-234.866 -161.367)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M317.571,178.932a8.7,8.7,0,0,0-6.545-8.006L299.3,167.935c-5.066-.546-8.45,5.687-8.783,10.773-.37,5.653-.6,11.614.064,15.832,1.326,8.477,7.823,9.576,7.823,9.576v6.511l3.923,16.246L314.97,209.4l2.618-30.363C317.6,178.891,317.571,179.125,317.571,178.932Z",
    transform: "translate(-240.302 -163.145)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M298.72,216.743a1.089,1.089,0,0,0,1.048,1.1,1.041,1.041,0,0,0,1.122-.98,1.089,1.089,0,0,0-1.044-1.1,1.041,1.041,0,0,0-1.126.98Z",
    transform: "translate(-245.96 -194.775)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M.022,1.139c.136.142.96-.465,2.13-.461s2.035.593,2.153.451C4.37,1.065,4.231.81,3.858.536A2.991,2.991,0,0,0,2.135,0,2.889,2.889,0,0,0,.44.543C.067.821-.056,1.075.022,1.139Z",
    transform: "translate(51.118 19.791) rotate(-21)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M328.8,216.736a1.089,1.089,0,0,0,1.048,1.1,1.038,1.038,0,0,0,1.122-.983,1.088,1.088,0,0,0-1.044-1.1,1.041,1.041,0,0,0-1.126.983Z",
    transform: "translate(-265.84 -194.768)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M327.7,207.339c.136.142.963-.465,2.133-.461s2.035.593,2.153.451c.061-.064-.075-.319-.448-.593a3.011,3.011,0,0,0-1.712-.536,2.906,2.906,0,0,0-1.7.543C327.756,207.021,327.634,207.275,327.7,207.339Z",
    transform: "translate(-265.795 -187.721)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M311.22,217.678a7.8,7.8,0,0,0-1.9-.339c-.3-.031-.58-.092-.631-.3a1.509,1.509,0,0,1,.2-.885q.424-1.082.888-2.275a39.333,39.333,0,0,0,2-5.944A39.446,39.446,0,0,0,309.3,213.7q-.448,1.194-.851,2.286a1.736,1.736,0,0,0-.159,1.173.746.746,0,0,0,.492.437,1.826,1.826,0,0,0,.505.071A7.594,7.594,0,0,0,311.22,217.678Z",
    transform: "translate(-252.262 -189.606)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M325.724,265.79s-2.76,5.836-11.244,5.012v-1.994A21.363,21.363,0,0,0,325.724,265.79Z",
    transform: "translate(-256.376 -227.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M.006.857c.115.319,1.282.17,2.655.339s2.482.546,2.665.261c.081-.139-.112-.437-.56-.746A4.408,4.408,0,0,0,2.794.033,4.486,4.486,0,0,0,.715.271C.21.457-.044.7.006.857Z",
    transform: "translate(51.067 15.35) rotate(-20)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M.031,1.205c.2.268,1.017,0,1.98-.017s1.79.183,1.98-.095c.081-.136-.047-.4-.4-.654A2.876,2.876,0,0,0,.4.53C.051.8-.061,1.076.031,1.205Z",
    transform: "translate(63.104 14.944) rotate(13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M297.689,164.563a3.739,3.739,0,0,1,3.293-2.109,7.237,7.237,0,0,1,3.913,1.139c5.049,2.92,7.647,9.969,12.635,12.991,1.228.743,2.825.061,3.869,1.044a3.6,3.6,0,0,1,1.143,3.869,11.9,11.9,0,0,0,1.733-2.926,4.011,4.011,0,0,0-.142-3.306c-.431-.749-1.194-1.319-1.4-2.157a11.094,11.094,0,0,1,.075-2.269,4.975,4.975,0,0,0-.777-2.163,22.059,22.059,0,0,0-8.108-8.528,14.368,14.368,0,0,0-7.443-1.923,10.98,10.98,0,0,0-7.094,2.811c-1.116,1.041-2.289,2.116-1.7,3.527",
    transform: "translate(-245.174 -156.749)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M367.56,217.661c.088-.244,4.513-1.838,4.571,2.862.058,4.568-4.551,3.669-4.561,3.537S367.56,217.661,367.56,217.661Z",
    transform: "translate(-291.457 -195.731)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M371.691,225.206c.02,0,.078.054.214.115a.807.807,0,0,0,.6,0,1.97,1.97,0,0,0,.892-1.773,2.622,2.622,0,0,0-.231-1.139.926.926,0,0,0-.607-.6.4.4,0,0,0-.465.22c-.061.129-.031.22-.058.227s-.1-.075-.061-.265a.509.509,0,0,1,.176-.285.59.59,0,0,1,.437-.122,1.112,1.112,0,0,1,.838.7,2.659,2.659,0,0,1,.288,1.268,2.06,2.06,0,0,1-1.143,1.984.848.848,0,0,1-.726-.112C371.7,225.318,371.674,225.216,371.691,225.206Z",
    transform: "translate(-294.184 -198.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M325.018,181.653a1.808,1.808,0,0,1-.275-.153c-.176-.112-.448-.261-.766-.488a15.633,15.633,0,0,1-2.469-2.245,44.238,44.238,0,0,1-3.015-3.917,35.747,35.747,0,0,0-3.767-4.693,14.3,14.3,0,0,0-2.435-1.923,11.981,11.981,0,0,0-2.625-1.194,13.016,13.016,0,0,0-4.839-.593,12.523,12.523,0,0,0-3.242.634c-.376.115-.654.241-.848.315a1.737,1.737,0,0,1-.3.105,2.2,2.2,0,0,1,.281-.142,7.35,7.35,0,0,1,.838-.339,11.687,11.687,0,0,1,3.259-.705,12.95,12.95,0,0,1,4.907.543,11.965,11.965,0,0,1,2.675,1.2,14.581,14.581,0,0,1,2.472,1.95,34.99,34.99,0,0,1,3.778,4.747,47.224,47.224,0,0,0,2.97,3.93,17.057,17.057,0,0,0,2.4,2.279c.312.234.573.393.739.515a1.866,1.866,0,0,1,.254.173Z",
    transform: "translate(-247.097 -162.069)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M371.8,234.631a.9.9,0,1,1-.214.068",
    transform: "translate(-293.77 -207.237)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M371.454,234.649a1.237,1.237,0,0,0-.41.614.773.773,0,0,0,.176.715.8.8,0,0,0,1.407-.444.777.777,0,0,0-.271-.678,1.217,1.217,0,0,0-.678-.264.412.412,0,0,1,.214-.051.933.933,0,0,1,.57.2.916.916,0,0,1,.366.824.98.98,0,0,1-1.74.553.916.916,0,0,1-.176-.882.9.9,0,0,1,.339-.492C371.37,234.652,371.451,234.638,371.454,234.649Z",
    transform: "translate(-293.642 -207.187)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M357.931,202.8a7.038,7.038,0,0,1-.448,3.672,2.424,2.424,0,0,1-3.113,1.244,3.465,3.465,0,0,1-1.3-2.648c-.431-2.909-.631-5.849-1.089-8.755Z",
    transform: "translate(-281.16 -181.921)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M301.32,170.1c0,.024.4-.078,1.133-.1a7.894,7.894,0,0,1,3.025.553,9.972,9.972,0,0,1,1.892.977,20.1,20.1,0,0,1,1.953,1.492,23.314,23.314,0,0,1,3.825,4.123c.58.814,1.1,1.651,1.651,2.428a11.837,11.837,0,0,0,1.831,2.058,20.48,20.48,0,0,0,3.859,2.581c1.17.617,2.146,1.051,2.821,1.356l.78.339a1.379,1.379,0,0,0,.281.1,1.31,1.31,0,0,0-.258-.146l-.763-.376c-.678-.339-1.624-.787-2.774-1.421a21.118,21.118,0,0,1-3.791-2.611A11.569,11.569,0,0,1,315,179.421c-.546-.766-1.058-1.6-1.645-2.428a22.949,22.949,0,0,0-3.879-4.154,20.054,20.054,0,0,0-1.994-1.492,9.952,9.952,0,0,0-1.943-.966,7.585,7.585,0,0,0-3.093-.482,5.246,5.246,0,0,0-.844.119,1.085,1.085,0,0,0-.285.085Z",
    transform: "translate(-247.679 -164.458)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M369.9,195.693a2.073,2.073,0,0,0,.4.271l1.16.678.387.22a1.187,1.187,0,0,0,.5.166.482.482,0,0,0,.309-.071.4.4,0,0,0,.17-.3,1.018,1.018,0,0,0-.214-.576l-1.356-2.15-.183.166a4.788,4.788,0,0,0,3.1.926,1.316,1.316,0,0,0,.417-.071.56.56,0,0,0,.339-.309.5.5,0,0,0-.078-.461,1.789,1.789,0,0,0-.258-.285,9.518,9.518,0,0,1-1.556-1.963,16.43,16.43,0,0,1-.99-2.1,2.4,2.4,0,0,0,.146.614,8.292,8.292,0,0,0,.678,1.58,9.061,9.061,0,0,0,1.546,2.035c.17.163.339.339.275.492s-.315.217-.556.217a4.6,4.6,0,0,1-1.546-.186,4.653,4.653,0,0,1-1.394-.678l-.543-.4.363.566,1.356,2.133a.868.868,0,0,1,.193.448c0,.129-.115.2-.261.193a2.265,2.265,0,0,1-.821-.339l-1.194-.61A2.11,2.11,0,0,0,369.9,195.693Z",
    transform: "translate(-293.003 -177.638)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M.029,1.906a1.526,1.526,0,0,0,1.577,1.16,1.584,1.584,0,0,0,1.228-.871A1.963,1.963,0,0,0,2.9.665L2.877.556A1.74,1.74,0,0,0,.92.139,1.624,1.624,0,0,0,.029,1.906Z",
    transform: "translate(61.14 29.347) rotate(20)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M3.266.209c0,.176-1.183.122-2.075,1.092S.371,3.539.2,3.539c-.075,0-.217-.292-.2-.827A2.943,2.943,0,0,1,.757.843,2.574,2.574,0,0,1,2.493,0C2.982-.018,3.277.127,3.266.209Z",
    transform: "translate(61.467 29.799) rotate(20)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M375.957,459a.3.3,0,0,1-.078,0l-.237.024-.905.075c-.787.064-1.926.139-3.337.224-2.818.166-6.714.339-11.021.41s-8.213.031-11.034-.044c-1.411-.034-2.553-.075-3.34-.109l-.909-.047H346l3.344.058c2.821.041,6.721.061,11.027,0s8.2-.224,11.017-.359l3.34-.166.909-.041h.234Z",
    transform: "translate(-276.402 -355.533)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationToken);
export default __webpack_public_path__ + "static/media/illustration-token.f9965275caa1ed08c3765702f74373ac.svg";
export { ForwardRef as ReactComponent };